import React, { Component } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, withStyles, Typography, Container, Grid } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import MainContext from '../../MainContext';

const styles = (theme) => ({
  title: {
    paddingBottom: '0px',
  },
  titleText01: {
    fontWeight: '900',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {},
  },
  titleText02: {
    fontSize: '15.5px',
    margin: '3px 0px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13.5px',
    },
  },
  scoreList: {
    padding: '10px 0 7px 15px',
    margin: 0,
    fontSize: '1.1em',
    '& p': {
      textIndent: '-5px',
    },
    '& p:before': {
      content: '"-"',
      textIndent: '-5px',
    },
  },
  agreeBtn: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    // marginBottom: '40px',
    // minWidth: '50%',
    width: '100%',
    padding: '10px 0',
    textTransform: 'unset !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      padding: '16px',
      minWidth: '100%',
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  contentTitle: {
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  contentTitle2: {
    fontSize: '1.2em',
    fontWeight: 'normal',
  },
  warning: {
    color: '#d54a50',
    fontSize: '0.9em',
  },
  orderNum: {
    width: '20px',
  },
  orderContent: {
    width: 'calc(100% - 20px)',
  },
});

const theme = createTheme({
  typography: {},
});

class BaseDialog extends Component {
  static contextType = MainContext;
  constructor(props) {
    super(props);
    this.state = {
      value: true,
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, open, onClose } = this.props;
    return (
      <ThemeProvider theme={theme}>
        <Dialog
          onClose={onClose}
          aria-labelledby="channel-enter-dialog"
          open={open}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
        >
          <div style={{ padding: '16px' }}>
            <DialogTitle id="channel-enter-dialog" onClose={onClose} className={classes.title}>
              <p style={{ fontWeight: 'normal', fontSize: 13, lineHeight: '15px', paddingBottom: 10, color: '#555' }}>
                **This message is only for Korean Faculty. For international faculty, please click the ‘Enter’ button.
              </p>
              <div>
                <p className="titleText01">
                  <span style={{ color: '#de3e36' }}>Notice</span>
                </p>
              </div>
            </DialogTitle>
            <DialogContent>
              <Container
                maxWidth="md"
                style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f7f9fa', borderRadius: '5px' }}
              >
                <ol style={{ paddingLeft: '4px', listStyleType: 'none' }}>
                  {/* <li>
                    <p className={classes.contentTitle}>1) Requirement of CME Credit</p>
                    <ul className={classes.scoreList}>
                      <li>
                        - Whenever the session starts/ends, you should click the button of ‘Session In’, ‘Session Out’ on the top of the
                        right side to receive the CME Credit.
                      </li>
                      <span style={{ color: '#de3e36' }}>(1 credit of CME is allowed per 60 minutes of the session)</span>
                    </ul>
                  </li>

                  <li>
                    <p className={classes.contentTitle}>
                      2) After all programs ends, please click ‘log-out’ button on the top of the right side of the main page.
                    </p>
                    <ul className={classes.scoreList}>
                      <li>(If you close the webpage before the session finishes, cannot receive CME Credit.)</li>
                    </ul>
                  </li> */}
                  <li>
                    <p className={classes.contentTitle}>1. 평점인정</p>
                    <ul className={classes.scoreList}>
                      <li>
                        각 세션 시작과 종료 시 우측 상단의 ‘SESSION IN’과 ‘SESSION OUT’ 버튼을 눌러야 누적된 수강 시간으로 평점이
                        인정됩니다.
                      </li>
                    </ul>
                  </li>

                  <li>
                    <p className={classes.contentTitle}>
                      2. 전체 프로그램 종료 후 메인 우측 상단의 ‘Logout’ 버튼을 반드시 클릭해주시기 바랍니다.&nbsp;
                      <span style={{ color: '#de3e36' }}>(강제 종료시, 평점 인정 불가)</span>
                    </p>
                  </li>
                </ol>
              </Container>
            </DialogContent>
          </div>

          <Grid container justifyContent="center" alignItems="center">
            {/*<Grid container justifyContent="center">*/}
            {/*  <FormControlLabel*/}
            {/*    value={this.state.value}*/}
            {/*    control={<Checkbox color="secondary" />}*/}
            {/*    label="모든 내용을 확인했고 동의합니다."*/}
            {/*    onChange={this.handleChange}*/}
            {/*  />*/}
            {/*</Grid>*/}
            <Grid container justifyContent="center">
              <Button onClick={onClose} variant="contained" size="large" className={classes.agreeBtn} disabled={!this.state.value}>
                <Typography>
                  위 사항을 확인하였습니다
                  <br />
                  <b style={{ fontSize: 'large' }}>Enter</b>
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Dialog>
      </ThemeProvider>
    );
  }
}
export default withStyles(styles, { withTheme: true })(BaseDialog);
